// 全局插件工具
import request from './request'

/**
 * 生成代理图片 URL
 * @param {string} url - 原始图片 URL
 * @returns {string} 代理后的图片 URL
 */
export function getProxyUrl(url) {
  if (!url) return ''
  
  // 如果已经是代理 URL，直接返回
  if (url.includes('/api/proxy?url=')) {
    return url
  }
  
  // 构建代理 URL
  const baseUrl = request.defaults.baseURL
  return `${baseUrl}/api/proxy?url=${encodeURIComponent(url)}`
}

/**
 * 安装为 Vue 全局方法
 * @param {Object} app - Vue 应用实例
 */
export function install(app) {
  app.config.globalProperties.$getProxyUrl = getProxyUrl
}

export default {
  getProxyUrl,
  install
}